import { AdresaVO, SoudniSporVO } from "./api";
import { MenuItemProps } from "@mc/ui-v4";
import { NavBarMenuLayoutProps } from "@mc/ui-v4/dist/navbar/NavBarMenuLayout";
import { formatDate } from "@mc/react-format";
import { NAVBAR_ITEMS } from "./constans";
import { Link } from "react-router-dom";
import React from "react";

const formatujAdresu = (adresa: AdresaVO) => {
  return `${adresa.nazevUlice} ${adresa.cisloDomovni}, ${adresa.nazevCastObce} ${adresa.cisloOrientacni}, ${adresa.nazevObec}`;
};
export const getNavbarProps = (currentKey?: string) => {
  return {
    defaultVisibleMenu: true,
    brand: <Link to={"/soudni-spory"}>Soudní spory</Link>,
    appMenu: { menuItems: NAVBAR_ITEMS, currentKey: currentKey },
  };
};

export const formatSubjekt = (
  adresa: string,
  ic?: string,
  datumNarozeni?: string
) => {
  return ` ${
    ic ? `IČ: ${ic}` : `nar. ${formatDate(datumNarozeni)}`
  }, ${adresa}`;
};
